import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoadingSpinner } from '../components/LoadingSpinner';
import { LandingPage } from './LandingPage';
import { PAGE_CHROME_LIGHT, PAGE_CHROME_LOADER_BRAND_GREEN } from '../constants/pageChrome';
import { hasStoredSupabaseSession } from '../lib/bootSessionChrome';

export const Home = () => {
  const { user, profile, loading } = useAuth();
  const bootLoaderStatusBg = hasStoredSupabaseSession()
    ? PAGE_CHROME_LOADER_BRAND_GREEN
    : PAGE_CHROME_LIGHT;
  const navigate = useNavigate();

  useEffect(() => {
    if (user && profile && !loading) {
      const timer = setTimeout(() => {
        if (profile.role === 'trainer') {
          navigate('/trainer-dashboard', { replace: true });
        } else {
          navigate('/member-dashboard', { replace: true });
        }
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [user, profile, loading, navigate]);

  if (loading) {
    return <LoadingSpinner fullScreen statusBarBackground={bootLoaderStatusBg} />;
  }

  if (!user) {
    return <LandingPage />;
  }

  if (!profile) {
    return <LoadingSpinner fullScreen statusBarBackground={bootLoaderStatusBg} />;
  }

  return <LoadingSpinner fullScreen statusBarBackground={bootLoaderStatusBg} />;
};

export default Home;
